export const gachaSentToastContainerClassName =
  "flex w-full items-center justify-between gap-3 rounded-xl border bg-foregroundInvert/95 py-3 pr-1 pl-2 font-body shadow-custom-brand backdrop-blur-lg md:gap-4 md:px-4"

export const gachaSentToastSubtitleClassName =
  "min-w-0 text-foreground/60 text-sm md:whitespace-nowrap"

export const gachaSentToastSonnerOptions = {
  classNames: {
    toast:
      "w-full max-w-[calc(100vw-2rem)] md:min-w-[440px] md:max-w-[560px] sm:translate-x-[-12%]",
  },
  style: {
    maxWidth: "min(100vw - 2rem, 560px)",
  },
} as const
